import { render } from "./next-link.vue?vue&type=template&id=76e94067&scoped=true&ts=true"
import script from "./next-link.vue?vue&type=script&lang=ts"
export * from "./next-link.vue?vue&type=script&lang=ts"

import "./next-link.vue?vue&type=style&index=0&id=76e94067&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e94067"]])

export default __exports__